import React, {useState, useRef, useEffect} from 'react';
import Slider from "react-slick";
import moment from 'moment';
import PauseIcon from '@mui/icons-material/Pause';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import {Accordion, AccordionDetails} from "@mui/material";
import {getRealtimeNewsAPI} from "../../apis/news_service";


const RealtimeNews = () => {
    const sliderRef = useRef();
    const [newsList, setNewsList] = useState([]);
    const [play, setPlay] = useState(true);
    const [open, setOpen] = useState(false);
    const settings = {
        dots: false,
        vertical: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        verticalSwiping: true,
        autoplay: true,
        speed: 1000,
        autoplaySpeed: 5000,
        arrows: false
    };

    useEffect(()=> {
        getRealtimeNewsAPI()
            .then(res => setNewsList(res))
            .catch(err => console.log(err))
    },[])

    useEffect(()=>setOpen(false), [window.location.pathname])


    const pauseClick = () => {
        setPlay(prevState => !prevState)
        if(play){sliderRef.current.slickPause();}
        else {sliderRef.current.slickPlay();}
        setOpen(false)
    }

    const newsTime = (idx) => {
        const nowTime = moment()
        const registerTime = newsList[idx].registdate;
        const newRegisterTime = registerTime.replaceAll('오후', 'pm').replaceAll('오전', 'am')
        const targetNewsTime = moment(newRegisterTime,'YYYY.MM.DD. a hh:mm');
        const newsTime = moment.duration(nowTime.diff(targetNewsTime)).asMinutes()

        const mins = Math.floor(newsTime)

        if(mins < 60){
            return mins + '분전'
        } else if(mins >= 60 && mins <1440) {
            return Math.floor(mins / 60) + '시간전'
        }else {
            return Math.floor(mins/60/24) + '일전'
        }

    }


    const setColor = (signal) => {
        if(signal === '긍정') return '#f86e8e'
        else if (signal === '부정') return '#3d6ae6'
        return '#555'
    }

    const moveToStock = (news) => {
        setOpen(false)
        window.location.replace(`/stock/${news.stockcode}`)
    }

    return (
        <div className='realtime_news container'>
            <div>
                <Accordion expanded={open} sx={{zIndex:100, boxShadow:'none', borderBottom:'1px solid #eee'}}>
                    <div className='summary inner_container flex_layout'>
                        <span className='recent' >최신</span>
                        <Slider {...settings} ref={sliderRef} style={{paddingTop: '4px'}}>
                            {newsList.map((news) => (
                                <div key={news.newsid} >
                                    <a href={news.url} target="_blank" rel="noopener noreferrer">
                                        <span className='title' >{news.subject.length >= 40 ? news.subject.slice(0, 40)+'...' :  news.subject}</span>
                                    </a>
                                </div>
                            ))}
                        </Slider>
                        <div className='btns'>
                            {play ? <PauseIcon  onClick={pauseClick}/> : <PlayArrowIcon onClick={pauseClick}/>}
                            <ArrowDropDownIcon onClick={()=> setOpen(!open)} />
                        </div>
                    </div>

                    <AccordionDetails sx={{boxShadow: '0 3px 10px 0 rgba(0, 0, 0, 0.3)'}}>
                        <ul className='inner_container'>
                            {newsList.map((news, idx) => (
                                <li key={news.newsid} className='drawer'>
                                    <p className='drawer_stockname' onClick={()=>moveToStock(news)}>
                                       {news.stockname.length > 6 ? news.stockname.slice(0, 6) + '...' : news.stockname}
                                    </p>
                                    <p style={{color:news.parentstype === 0 ? '#3d6ae6' : '#777'}}>{news.parentstype === 0 ? '최초' : `${news.samenewsseq}보`}</p>
                                    <a rel="noopener noreferrer" href={news.url} target="_blank">
                                        <p className='drawer_title' >{news.subject.length >= 40 ? news.subject.slice(0, 40) + '...' : news.subject}</p>
                                    </a>
                                    <p className='drawer_samenewscounts'>연관뉴스 {news.samenewscounts}건</p>
                                    <p className='drawer_press'>{news.press}</p>
                                    <p style={{color:setColor(news.staticsentimental.signal)}}>{news.staticsentimental.signal} {news.staticsentimental.percent}%</p>
                                    <p className='drawer_time'>{newsTime(idx)}</p>
                                </li>
                            ))}
                        </ul>
                    </AccordionDetails>
                </Accordion>
            </div>
        </div>
    );
};

export default RealtimeNews;